import Icon from '../../components/Icon.vue'

Icon.register({"brands/rebel":{"width":512,"height":512,"paths":[{"d":"M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5 130 49.5 131.6 48.9 130.8 50.3 125 55.8 19.5 180.1 116.7 276.7 166.5 326.2 206.7 279.2 206.7 279.2 245.2 229.1 206.1 153.3 206.1 153.3 196.1 128.4 160.4 113.2 160.4 113.2L189.2 81.4C213.6 91.9 232.4 120.1 232.4 120.1 233.2 90.5 210.5 58.7 210.5 58.7L255.1 8 299.4 58.1C278.9 86.9 277.5 120.7 277.5 120.7 291.3 97.7 321 81.4 321 81.4L349.5 113.2C322.1 122.1 304.1 153.1 304.1 153.1 288.3 181.6 277 242.5 304.7 280.4 337.1 325 392.4 277.6 392.4 277.6 495.1 185.7 381.9 52.6 381.9 52.6 375.8 47.1 382.7 49.8 382.7 49.8 432.8 86.3 497.3 134.2 498.9 254.6 500.9 400.2 399 504 256.5 504z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/rebel.js
// module id = null
// module chunks = 